export const truncateValues = (val: string) => {
  const str = val

  const length = str.length;

  if (length > 6) {
      return `${(parseFloat(str) / 1000000).toFixed(1).replace('.0', '')}M`
  } else if (length > 3) {
      return `${(parseFloat(str) / 1000).toFixed(1).replace('.0', '')}K`
  } else {
    return val
  }
}